import React from 'react'
import { Router, Location, Redirect } from '@reach/router'
import ScrollToTopBtn from './menu/ScrollToTop'
import Header from './menu/header'
import Home from './pages/home'
import AdminHome from './pages/admin'


import { createGlobalStyle } from 'styled-components'

const GlobalStyles = createGlobalStyle`
  :root {
    scroll-behavior: unset;
  }
`

export const ScrollTop = ({ children, location }) => {
  React.useEffect(() => window.scrollTo(0, 0), [location])
  return children
}

const PosedRouter = ({ children }) => (
  <Location>
    {({ location }) => (
      <div id="routerhang">
        <div key={location.key}>
          <Router location={location}>{children}</Router>
        </div>
      </div>
    )}
  </Location>
)


const App = () => {
  
  // const alert = useAlert()
  return (
  <div className="wraper">
    <GlobalStyles />
    <Header />
    <PosedRouter>
      <ScrollTop path="/">
        <Home exact path="/">
          <Redirect to="/home" />
        </Home>
        <AdminHome path="/admin" />
      </ScrollTop>
    </PosedRouter>
    <ScrollToTopBtn />
  </div>
  )
}
export default App
